import { render, staticRenderFns } from "./ModalSkuList.vue?vue&type=template&id=18bb4704&scoped=true&"
import script from "./ModalSkuList.vue?vue&type=script&lang=js&"
export * from "./ModalSkuList.vue?vue&type=script&lang=js&"
import style0 from "./ModalSkuList.vue?vue&type=style&index=0&id=18bb4704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb4704",
  null
  
)

export default component.exports